import { Tabs } from "flowbite-react";
import { useState } from "react";
import { useQuery, useQueryClient } from "react-query";
import {
  MdAlignHorizontalLeft,
  MdOutlinePayments,
  MdThumbDownOffAlt,
} from "react-icons/md";
import { FaChartBar, FaMagnifyingGlass } from "react-icons/fa6";
import { IoDocumentOutline, IoPeopleSharp } from "react-icons/io5";
import AdminPaymentsTable from "../components/tables/AdminPaymentsTable";
import AdminHistoryTable from "../components/tables/AdminHistoryTable";
import AdminReportSurveysTable from "../components/tables/AdminReportSurveysTable";
import AdminHistoryGeneralTable from "../components/tables/AdminHistoryGeneralTable";
import { BsCashCoin } from "react-icons/bs";
import AdminCloseTable from "../components/tables/AdminCloseTable";
import { useApplication } from "../contexts/ApplicationContext";
import { LiaSellsy } from "react-icons/lia";
import AdminHistoryTableProviders from "../components/tables/AdminHistoryTableProviders";
import { VscDebugConsole } from "react-icons/vsc";
import AdminLogErrorsProviders from "../components/tables/AdminLogErrorsProviders";
import AdminCVsTable from "../components/tables/AdminCVsTable";
import { GrDocumentTransfer } from "react-icons/gr";
import ReviewDiario from "./ReviewDiarioPage";
import AdminNegativeTable from "../components/tables/AdminNegativeTable";

const ReportsPage = () => {
  const { userPermission } = useApplication();
  const queryClient = useQueryClient();
  const [activeTab, setActiveTab] = useState(0);

  return (
    <>
      <div className="bg-white px-4 py-4 rounded-md shadow-md relative">
        <Tabs
          aria-label="Default tabs"
          id="tab-company-details"
          activeTab={activeTab}
          onActiveTabChange={(tabIndex) => setActiveTab(tabIndex)}
        >
          {/* <Tabs.Item title="Resumo Geral" icon={MdAlignHorizontalLeft}>
            <AdminHistoryGeneralTable />
          </Tabs.Item> */}
          <Tabs.Item title="Consultas" icon={FaMagnifyingGlass}>
            <AdminHistoryTable isActive={activeTab === 0} />
          </Tabs.Item>
          <Tabs.Item title="Negativações" icon={MdThumbDownOffAlt}>
            <AdminNegativeTable isActive={activeTab === 1} />
          </Tabs.Item>
          {userPermission === "POWER_USER" && (
            <Tabs.Item title="Consumo de Provedores" icon={LiaSellsy}>
              <AdminHistoryTableProviders isActive={activeTab === 2} />
            </Tabs.Item>
          )}
          {userPermission === "POWER_USER" && (
            <Tabs.Item title="Log de erros" icon={VscDebugConsole}>
              <AdminLogErrorsProviders isActive={activeTab === 3} />
            </Tabs.Item>
          )}
        </Tabs>
      </div>
    </>
  );
};

export default ReportsPage;
